import { autoinject } from "aurelia-dependency-injection";
import { EntityAttachmentModel } from "../../models/attachments.models";
import { FileHelper } from "../../helpers/file-helper";
import { AttachmentsHelper } from "../../helpers/attachments.helper";
import { AttachmentsClientService } from "./attachments-client.service";
import { NotificationClientService, NotificationType } from "../basic/notification-client.service";
import { ConfigService } from "../basic/config.service";

@autoinject()
export class EntityAttachmentManager {

    private baseUrl: string;
    private blobStorageUrl: string;
    private defaultContainer: string;

    constructor(private attachmentClientService: AttachmentsClientService, private notificationClientService: NotificationClientService, private configService: ConfigService) {
        this.baseUrl = this.configService.config.urls.rightShipPlatformApiUrl;
        this.blobStorageUrl = this.configService.config.urls.blobStorageUrl;
        this.defaultContainer = this.configService.config.common.defaultStorageContainer;
    }

    public open(item: EntityAttachmentModel, fileName?: string) {
        this.attachmentClientService.getSharedAccessSignatureToken(item.entityAttachmentId, true).then(sasToken => {
            let url = AttachmentsHelper.getUrl(item.path, this.blobStorageUrl, this.defaultContainer);
            if (sasToken) {
                url += ((sasToken.startsWith("?") ? "" : "?") + sasToken);
            } else {
                url = `${this.baseUrl}/${url}`
            }

            const link = document.createElement('a');

            link.setAttribute('href', `${url}`);

            fileName = fileName || item.name || '';
            if (fileName) {

                const fileNameExtension = FileHelper.getFileExtension(fileName).toLowerCase();
                const itemPathNameExtension = FileHelper.getFileExtension(item.path).toLowerCase();

                if (!fileNameExtension || (fileNameExtension != itemPathNameExtension)) {
                    link.setAttribute('download', fileName + (itemPathNameExtension ? ("." + itemPathNameExtension) : ''));
                } else {
                    link.setAttribute('download', fileName);
                }
            }
            link.click();
            link.remove();
        }).catch(() => {
            this.notificationClientService.show("Error", "You do not have enough permissions to open/download this file", NotificationType.Error);
        });
    }

    public getExtension(item: EntityAttachmentModel) {
        if (item && item.path)
            return FileHelper.getFileExtension(item.path);
    }
}